export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {

      $(`#${widgetName} .card-widget-item`).each(function (x) {

        let sourceData = data.items[x];
        const newTitle = `<h1>${sourceData.Title} <span>${sourceData.DetailLinkText}</span></h1>`

        $(this).find('.card-content').prepend(newTitle);
        $(this).find('.card-widget-title').remove();
        $(this).find('.moreButton').addClass('button');
        $(this).find('.button').removeClass('moreButton');
        $(this).find('.button').removeAttr('target');

        if (data.items[x].ImageAlternateText == data.items[x].Title) {
          $(this).find('.card-widget-image').attr('alt', `${data.items[x].Title} ${data.items[x].DetailLinkText}`);
        }

      })

      if (data.items.length == 0) {
        $(`#${widgetName}`).remove();
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''], 
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}